import React, { Component } from "react";

// import UI components
import { Row, Col } from "reactstrap";
import CustomisedModal from "components/Application/CustomisedModal";
import {
  downloadFile,
  formatDateTime,
  formatOnlyAddress,
  getFileExtension,
} from "helpers/generalUtils";

import {} from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import ProductSlipStatus from "./ProductSlipStatus";

class ProductSlipModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.orderDetailApiResponse &&
      this.props.orderDetailApiResponse !== nextProps.orderDetailApiResponse
    ) {
      if (nextProps.orderDetailApiResponse.isSuccessResponse) {
        this.props.getOrderDetailWithLinesByOrderIdRequest(
          this.props.orderDetailData.orderDetailId
        );
      }
    }
  }

  getFileName = (fileUrl, productSlipNo, index) => {
    return (
      productSlipNo + "_file_" + (index + 1) + "." + getFileExtension(fileUrl)
    );
  };

  handleDownloadClick = async (fileUrl, fileName) => {
    downloadFile(fileUrl, fileName);
  };

  render() {
    let modalData = null;

    if (this.props.productSlipRecord) {
      let userAddressJson = this.props.productSlipRecord.userAddress || {};
      modalData = (
        <React.Fragment>
          <div className="order-heading">
            <div className="order-id">
              {this.props.productSlipRecord.productSlipNo}
            </div>
          </div>
          <div className="order-customer-info">
            <Row>
              <Col xs="12" lg="6">
                <table className="order-left-info">
                  <tbody>
                    <tr>
                      <td>Slip Date:</td>
                      <td>
                        {formatDateTime(
                          this.props.productSlipRecord.createdDate
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Customer Name:</td>
                      <td>{userAddressJson.rcvrName}</td>
                    </tr>
                    <tr>
                      <td>Mobile No:</td>
                      <td>{userAddressJson.rcvrMobileNo}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col xs="12" lg="6">
                <table className="order-left-right">
                  <tbody>
                    <tr>
                      <td>Address:</td>
                      <td>{formatOnlyAddress(userAddressJson)}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>
                        <ProductSlipStatus
                          status={
                            this.props.productSlipRecord.productSlipStatus
                          }
                          productSlipId={
                            this.props.productSlipRecord.productSlipId
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Username</td>
                      <td>{this.props.productSlipRecord.username}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>
          <div className="order-item">
            {this.props.productSlipRecord.productSlipImageUrl ? (
              <Row>
                {this.props.productSlipRecord.productSlipImageUrl.map(
                  (url, index) => (
                    <Col
                      key={index}
                      sm="6"
                      lg="4"
                      className="mb-2"
                      onClick={(event) => event.stopPropagation()}
                    >
                      <button
                        onClick={() =>
                          this.handleDownloadClick(
                            url,
                            this.getFileName(
                              url,
                              this.props.productSlipRecord.productSlipNo,
                              index
                            )
                          )
                        }
                        className="btn-link img-thumbnail btn-block text-left d-flex justify-content-between"
                      >
                        <span>File {index + 1}</span>
                        <i className="fa fa-download mr-2 mt-1"></i>
                      </button>
                    </Col>
                  )
                )}
              </Row>
            ) : (
              <textarea
                className="form-control product-slip-detail"
                defaultValue={this.props.productSlipRecord.productSlipDetail}
                readOnly
              />
            )}
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <CustomisedModal
          modalClass="modal-xl order-contents"
          isModalOpen={this.props.productSlipDialog}
          modalTitle="Product Slip"
          onModalDismiss={() => this.props.closeModal()}
        >
          {modalData}
        </CustomisedModal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({});

const withConnect = connect(mapStatetoProps, {});

export default compose(withConnect, withRouter)(ProductSlipModal);
